import { config } from "./Config";

const apib = config.apiBase;
export const Api = {
    mastercode: () => `${ apib }mastercode`,
    floorplans: () => `${ apib }floorplans`,
    object: (id: string) => `${ apib }object/${ id }`,
    floorplan: (id: string) => `${ apib }floorplan/${ id }`,
    cameras: () => `${ apib }cameras`,
    materialattributes: () => `${ apib }materialattributes`,
    healthcheck: () => `${ apib }healthcheck`,
};

export async function apiGet<T>(url: string): Promise<T> {
    const r = await fetch(url, { headers: { Accept: "application/json" } });
    if (!r.ok) { throw new Error(`${ r.status } ${ r.statusText }`); }
    return r.json() as Promise<T>;
}
